export default __webpack_public_path__ + "static/media/nhs-maidstone-and-tunbridge-wells.b5a71cd3.png";